var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.339,59.523 l-13.021,4.846l3.771-13.586l16.125-18.279c0.89-1.007,2.756-0.829,4.148,0.393l4.479,3.954c1.392,1.227,1.803,3.058,0.91,4.067 L58.339,59.523z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.152,
    y1: 57.928,
    x2: 50.258,
    y2: 50.959
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 49.283,
    y1: 62.686,
    x2: 46.717,
    y2: 60.367
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 54.469,
    y1: 54.533,
    x2: 63.597,
    y2: 44.186
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 61.962,
    y1: 36.614,
    x2: 71.078,
    y2: 44.656
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.115,57.486H12.552c-1.526,0-2.775-1.248-2.775-2.775V23.407c0-1.526,1.249-2.775,2.775-2.775h45.196 c1.525,0,2.775,1.249,2.775,2.775v6.105"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.845,
    y1: 42.39,
    x2: 11.382,
    y2: 56.109
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 10.766,21.627 35.226,40.509 59.481,21.472  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f4f1e57b2bc5ffb4b2d2573ad3e93917.svg";
export { ForwardRef as ReactComponent };